export { default as HistoricoInventarios } from "./HistoricoInventarios";

